import { render, staticRenderFns } from "./fp-pet.vue?vue&type=template&id=3c25a7cc&"
import script from "./fp-pet.vue?vue&type=script&lang=js&"
export * from "./fp-pet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c25a7cc')) {
      api.createRecord('3c25a7cc', component.options)
    } else {
      api.reload('3c25a7cc', component.options)
    }
    module.hot.accept("./fp-pet.vue?vue&type=template&id=3c25a7cc&", function () {
      api.rerender('3c25a7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/fp-pet.vue"
export default component.exports